import React from 'react';
import parse from 'html-react-parser';

export const Tabs = (props) => {
  const changeTabs = (e) => {
    e.preventDefault();
    const anchor = document.getElementById(e.target.hash.replace('#', ''));

    const tablist = document.getElementById('tablist').children;
    for(let i = 0; i < tablist.length; i++){
        tablist[i].classList.remove('active');
    }
    e.target.parentElement.classList.add('active');
    
    const tab_content_list = document.getElementById('tab-content').children;
    for(let j = 0; j < tab_content_list.length; j++){
        tab_content_list[j].classList.remove('active');
    }
    anchor.classList.add('active');
  }

  return (
    <>
      {/* Nav tabs */}
      <ul className="nav nav-tabs margin-top" role="tablist" id="tablist">
        {
          props.tabs.map((tab, index) => (
            <li role="presentation" className={`${index === 0 ? 'active' : ''}`} key={index}>
              <a href={`#${tab.name.split(' ').join('_')}`} aria-controls="desktop" role="tab" data-toggle="tab" onClick={changeTabs}>{tab.name}</a>
            </li>
          ))
        }
      </ul>

      {/* Tab panes */}
      <div className="tab-content" id="tab-content">
        {
          props.tabs.map((tab, index) => (
            <div role="tabpanel" className={`tab-pane ${index === 0 ? 'active' : ''}`} id={tab.name.split(' ').join('_')} key={index}>
              {parse(tab.content)}
            </div>
          ))
        }
      </div>
    </>
  )
}

